// extracted by mini-css-extract-plugin
export default {"root":"xtQR2iCpMD","header":"ooUwOX4ev9","titleRow":"fVs6kzDwlR","title":"KWi4cxlYay","headerContent":"MNbZKM0CcW","content":"TEAHqU78AA","footer":"n6Lvgxvhau"};